import { render, staticRenderFns } from "./numeric-score-entry.vue?vue&type=template&id=4b959f9e&scoped=true"
import script from "./numeric-score-entry.vue?vue&type=script&lang=js"
export * from "./numeric-score-entry.vue?vue&type=script&lang=js"
import style0 from "./numeric-score-entry.vue?vue&type=style&index=0&id=4b959f9e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b959f9e",
  null
  
)

export default component.exports